import { Role } from '../../../Helpers/AuthorizationDataProvider';

export enum Status {
	Pending = 'Pending',
	Active = 'Active',
	Rejected = 'Rejected',
	Accepted = 'Accepted',
}

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface Props {
	filters?: string
}

export interface UsersResponse {
	count: number
	users: {
		imageId?: string;
		isActive: boolean;
		firstName: string
		lastName: string
		location?: string
		role: Role
		userId: string
	}[]
}

export interface TableData {
	id: string
	isActive: boolean
	key: string
	location?: string
	name: string
	status?: Status
	imageId?: string
	userType: Role
}

